(() => {
  const locale = (document.documentElement.lang || navigator.language || 'fr').toLowerCase().split('-')[0];
  if (locale !== 'fr') return;

  const exact = new Map(Object.entries({
    'AUREKO store confidence':'Les engagements AUREKO',
    'Natural wood':'Bois naturel',
    'Warm, tactile body-care tools':'Des outils chaleureux et tactiles pour le soin du corps',
    'Secure checkout':'Paiement sécurisé',
    'Checkout powered by Shopify':'Paiement sécurisé par Shopify',
    'Clear returns':'Retours transparents',
    'Policy available before you order':'Conditions disponibles avant votre commande',
    'Customer support':'Service client',
    'Contact AUREKO when you need us':'Contactez AUREKO quand vous en avez besoin',
    'Choose your bundle size':'Choisissez le nombre de pièces',
    'Choose your bundle':'Choisissez votre kit',
    'Choose your tools':'Choisissez vos outils',
    'Choose tools':'Choisir les outils',
    'Your selection':'Votre sélection',
    'Your bundle':'Votre kit',
    'Build Your Wood Therapy Ritual':'Composez votre rituel de madérothérapie',
    'Build Your Wood Therapy Ritual — Choose Your Tools':'Composez votre rituel de madérothérapie — choisissez vos outils',
    'AUREKO Build Your Wood Therapy Ritual — Choose Your Tools':'AUREKO — Composez votre rituel de madérothérapie',
    'BUILD YOUR RITUAL':'COMPOSEZ VOTRE RITUEL',
    'BUILD YOUR OWN BUNDLE':'COMPOSEZ VOTRE KIT',
    'BUILD YOUR OWN SET':'COMPOSEZ VOTRE KIT',
    'Starter':'Découverte',
    'STARTER':'DÉCOUVERTE',
    'Most Popular':'Le plus choisi',
    'MOST POPULAR':'LE PLUS CHOISI',
    'Our Pick':'Notre choix',
    'OUR PICK':'NOTRE CHOIX',
    'Best Value':'Meilleur rapport',
    'BEST VALUE':'MEILLEUR RAPPORT',
    'Complete Ritual':'Rituel complet',
    'COMPLETE RITUAL':'RITUEL COMPLET',
    'Daily Ritual':'Rituel quotidien',
    'DAILY RITUAL':'RITUEL QUOTIDIEN',
    'Full Rotation':'Rotation complète',
    'FULL ROTATION':'ROTATION COMPLÈTE',
    'Gift Edit':'Édition cadeau',
    'Family Edit':'Édition famille',
    'Studio Edit':'Édition studio',
    'Selected tools':'Outils sélectionnés',
    'Bundle size':'Nombre de pièces',
    'Pieces':'Pièces',
    'Included':'Inclus',
    'Complimentary':'Offert',
    'Natural Massage Oil':'Huile de massage naturelle',
    'Massage Oil':'Huile de massage',
    'Free massage oil':'Huile de massage offerte',
    'Free oil':'Huile offerte',
    'Add to bag':'Ajouter au panier',
    'Add to cart':'Ajouter au panier',
    'Sold out':'Épuisé',
    'Checkout':'Paiement',
    'Continue to checkout':'Continuer vers le paiement',
    'Continue to secure checkout':'Continuer vers le paiement sécurisé',
    'Continue shopping':'Continuer mes achats',
    'Remove':'Supprimer',
    'Update':'Mettre à jour',
    'Quantity':'Quantité',
    'Qty':'Qté',
    'Subtotal':'Sous-total',
    'Total':'Total',
    'Estimated total':'Total estimé',
    'Your cart':'Votre panier',
    'Shopping cart':'Panier',
    'Your bag is empty.':'Votre panier est vide.',
    'Your ritual is waiting.':'Votre rituel vous attend.',
    'Shop AUREKO':'Découvrir AUREKO',
    'YOUR BAG':'VOTRE PANIER',
    'Almost yours.':'Presque à vous.',
    'Review your ritual before secure checkout.':'Vérifiez votre rituel avant le paiement sécurisé.',
    'Your tools':'Vos outils',
    'COMPLIMENTARY WITH YOUR KIT':'OFFERT AVEC VOTRE KIT',
    'COMPLIMENTARY WITH EVERY BUNDLE':'OFFERT AVEC CHAQUE KIT',
    '3 months of Natural Massage Oil included':'3 mois d’huile de massage naturelle offerts',
    '3 months of Natural Massage Oil included.':'3 mois d’huile de massage naturelle offerts.',
    '+ 3 months of Natural Massage Oil included':'+ 3 mois d’huile de massage naturelle offerts',
    'FREE':'OFFERT',
    'MORE RITUAL. MORE VALUE.':'PLUS DE RITUEL. PLUS DE VALEUR.',
    'Build beyond the basics.':'Allez au-delà de l’essentiel.',
    'UPGRADE YOUR RITUAL':'ENRICHISSEZ VOTRE RITUEL',
    'More tools. More variety.':'Plus d’outils. Plus de variété.',
    'See next bundle':'Voir le kit suivant',
    'NEXT BUNDLE':'KIT SUIVANT',
    'Upgrade bundle':'Passer au kit supérieur',
    'Edit bundle':'Modifier le kit',
    'Try again':'Réessayer',
    'Close':'Fermer',
    'Product image':'Image du produit',
    'Previous image':'Image précédente',
    'Next image':'Image suivante',
    'In stock':'En stock',
    'Out of stock':'Rupture de stock',
    'Sale':'Promotion',
    'Price':'Prix',
    'Order summary':'Récapitulatif de la commande',
    'Taxes included.':'Taxes incluses.',
    'Shipping calculated at checkout.':'Livraison calculée lors du paiement.',
    'Taxes and shipping calculated at checkout.':'Taxes et livraison calculées lors du paiement.',
    'Shipping and taxes calculated at checkout.':'Livraison et taxes calculées lors du paiement.',
    'Discount':'Réduction',
    'Discounts':'Réductions',
    'Apply':'Appliquer',
    'Learn more':'En savoir plus',
    'View details':'Voir les détails',
    'View product':'Voir le produit',
    'Contact us':'Nous contacter',
    'Returns policy':'Politique de retour',
    'Shipping policy':'Politique de livraison',
    'Privacy policy':'Politique de confidentialité',
    'Terms of service':'Conditions générales',
    'AUREKO IN MOTION':'AUREKO EN MOUVEMENT',
    'Nothing to switch on.':'Rien à allumer.',
    'Natural wood.':'Bois naturel.',
    'Quiet ritual · natural wood':'Rituel silencieux · bois naturel',
    'Natural body care':'Soin du corps naturel',
    'At-home body care':'Soin du corps à la maison',
    'French-inspired wellness':'Bien-être d’inspiration française',
    'Secure payment':'Paiement sécurisé',
    'Secure payments':'Paiements sécurisés'
  }));

  const skip = new Set(['SCRIPT','STYLE','NOSCRIPT','TEXTAREA','CODE','PRE']);
  const norm = s => String(s || '').replace(/\s+/g,' ').trim();

  function dynamic(text){
    let m;
    if ((m = text.match(/^Bag\s*\((\d+)\)$/i))) return `Panier (${m[1]})`;
    if ((m = text.match(/^(\d+) Pieces$/i))) return `${m[1]} pièces`;
    if ((m = text.match(/^(\d+) pieces$/i))) return `${m[1]} pièces`;
    if ((m = text.match(/^(\d+) piece$/i))) return `${m[1]} pièce`;
    if ((m = text.match(/^AUREKO · (\d+) Pieces$/i))) return `AUREKO · ${m[1]} pièces`;
    if ((m = text.match(/^(\d+) Pieces\s*[·•—-]\s*(.+)$/i))) return `${m[1]} pièces · ${m[2]}`;
    if ((m = text.match(/^(.+)\/piece$/i))) return `${m[1]}/pièce`;
    if ((m = text.match(/^Save\s+(\d+)%$/i))) return `Économisez ${m[1]} %`;
    if ((m = text.match(/^Save\s+(.+)$/i))) return `Économisez ${m[1]}`;
    if ((m = text.match(/^You save\s+(.+)$/i))) return `Vous économisez ${m[1]}`;
    if ((m = text.match(/^From\s+(.+)$/i))) return `À partir de ${m[1]}`;
    if ((m = text.match(/^Add to (?:bag|cart)\s*[·•—-]\s*(.+)$/i))) return `Ajouter au panier · ${m[1]}`;
    if ((m = text.match(/^Add (\d+)-piece bundle to bag$/i))) return `Ajouter le kit ${m[1]} pièces au panier`;
    if ((m = text.match(/^Choose (\d+) more pieces? to continue\.$/i))) return `Choisissez encore ${m[1]} ${Number(m[1])===1?'pièce':'pièces'} pour continuer.`;
    if ((m = text.match(/^Choose (\d+) more pieces?$/i))) return `Choisissez encore ${m[1]} ${Number(m[1])===1?'pièce':'pièces'}`;
    if ((m = text.match(/^(\d+) \/ (\d+) selected$/i))) return `${m[1]} / ${m[2]} sélectionné${Number(m[1])>1?'s':''}`;
    if ((m = text.match(/^([0-9]+)-piece bundle$/i))) return `Kit ${m[1]} pièces`;
    if ((m = text.match(/^([0-9]+) piece bundle$/i))) return `Kit ${m[1]} pièces`;
    if ((m = text.match(/^(\d+) → (\d+) pieces$/i))) return `${m[1]} → ${m[2]} pièces`;
    if ((m = text.match(/^Explore (\d+) pieces →$/i))) return `Découvrir ${m[1]} pièces →`;
    if ((m = text.match(/^Keep (\d+) pieces & checkout$/i))) return `Garder ${m[1]} pièces et payer`;
    if ((m = text.match(/^Only (\d+) left$/i))) return `Plus que ${m[1]} en stock`;
    return null;
  }

  function translateTextNode(node){
    if (!node || !node.parentElement || skip.has(node.parentElement.tagName)) return;
    const raw = node.nodeValue;
    const key = norm(raw);
    if (!key) return;
    const out = exact.get(key) || dynamic(key);
    if (!out || out === key) return;
    const lead = raw.match(/^\s*/)?.[0] || '';
    const trail = raw.match(/\s*$/)?.[0] || '';
    node.nodeValue = lead + out + trail;
  }

  function translateAttrs(el){
    if (!(el instanceof Element) || skip.has(el.tagName)) return;
    ['aria-label','placeholder','title','data-label'].forEach(attr => {
      if (!el.hasAttribute(attr)) return;
      const key = norm(el.getAttribute(attr));
      const out = exact.get(key) || dynamic(key);
      if (out) el.setAttribute(attr,out);
    });
  }

  function walk(root){
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) return translateTextNode(root);
    if (![Node.ELEMENT_NODE,Node.DOCUMENT_FRAGMENT_NODE,Node.DOCUMENT_NODE].includes(root.nodeType)) return;
    if (root.nodeType === Node.ELEMENT_NODE) translateAttrs(root);
    const walker = document.createTreeWalker(root,NodeFilter.SHOW_TEXT|NodeFilter.SHOW_ELEMENT,{
      acceptNode(node){
        if(node.nodeType===Node.ELEMENT_NODE && skip.has(node.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    let node;
    while((node=walker.nextNode())) node.nodeType===Node.TEXT_NODE ? translateTextNode(node) : translateAttrs(node);
  }

  function init(){
    walk(document.body);
    const observer = new MutationObserver(mutations => {
      for(const mutation of mutations){
        if(mutation.type==='characterData') translateTextNode(mutation.target);
        mutation.addedNodes.forEach(walk);
        if(mutation.type==='attributes') translateAttrs(mutation.target);
      }
    });
    observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','placeholder','title','data-label']});
    [120,350,800,1600,3000,5500].forEach(ms=>setTimeout(()=>walk(document.body),ms));
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
